import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';
import { from } from 'rxjs/observable/from';
import { AuthService } from '../../core/services/auth/auth.service';

declare var window: any;

@Injectable()
export class AppInitService {

  // This is the method you want to call at bootstrap
  // Important: It should return a Promise

  // public init(key): Promise<any> {
  //   return from(
  //     fetch(`assets/environments/app-config-${key}.json`).then(
  //       (data) => {
  //         return data.json();
  //       }
  //     )
  //   ).pipe(
  //     map((config) => {
  //       window.config = config;
  //       return config;
  //     })
  //   ).toPromise();
  // }

  constructor(private authService: AuthService){

  }

  public  async init() {
    window.config = {}
    const flag = await this.authService.isLogin();
   
    if(!flag){
      const key = 'default';
      const p = await import(`../../../assets/environments/app-config-${key}.js`).then((x:any) => {
        window.config = {}
        window.config =  x.default;
        return x.default;
      });
      return p;
    }else{
      const short_name: any = await this.authService.getShortName();
      const p = await import(`../../../assets/environments/app-config-${short_name}.js`).then((x:any) => {
        window.config = {}
        window.config =  x.default;
        return x.default;
       });
      return p;
    }
    
  
    
   }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/app-init.service.ts